{
  "app": {
    "eyebrow": "非官方忘却前夜工具",
    "title": "忘却前夜队伍构筑器",
    "metaDescription": "快速、非官方的忘却前夜十队构筑工具。",
    "about": "数据",
    "switchToChinese": "切换到简体中文",
    "switchToEnglish": "切换到英文",
    "chineseShort": "中",
    "englishShort": "EN",
    "footer": "非商业同人项目 · 与 Qookka Games 无关联",
    "attribution": "SKeyDB 署名与素材声明"
  },
  "navigation": {
    "label": "主导航",
    "builder": "队伍构筑",
    "recommended": "推荐队伍"
  },
  "builder": {
    "activeFormation": "当前编队 · {{number}}",
    "teamName": "队伍名称",
    "rename": "重命名队伍",
    "chooseRealms": "最多选择两个界域",
    "realmCount": "{{count}}/2 界域",
    "import": "导入",
    "clear": "清空",
    "clearNamed": "清空{{name}}",
    "copyReady": "复制可用于游戏的队伍代码",
    "copy": "复制代码",
    "copied": "已复制",
    "copiedToast": "队伍代码已复制到剪贴板。",
    "teamPosse": "编队技能",
    "choosePosse": "选择编队技能",
    "posseHint": "为整支队伍提供行动效果。",
    "loadouts": "唤醒体配置",
    "awakener": "唤醒体",
    "chooseAwakener": "选择唤醒体",
    "chooseAwakenerSlot": "为第 {{number}} 个位置选择唤醒体",
    "awakenerSlotLabel": "唤醒体位置 {{number}}：{{name}}",
    "wheelNumber": "命轮 {{number}}",
    "chooseWheel": "选择命轮",
    "chooseWheelSlot": "为位置 {{slot}} 选择命轮 {{wheel}}",
    "wheelSlotLabel": "位置 {{slot}}，命轮 {{wheel}}：{{name}}",
    "chooseCovenant": "选择密契",
    "chooseCovenantSlot": "为第 {{number}} 个位置选择密契",
    "covenantSlotLabel": "位置 {{number}}，密契：{{name}}",
    "posseSlotLabel": "编队技能：{{name}}",
    "empty": "空",
    "add": "添加",
    "lineupSet": "十队阵容",
    "teamCount": "10 支队伍",
    "reset": "重置",
    "resetConfirm": "重置全部十支队伍？",
    "teamsLabel": "十支队伍",
    "defaultTeam": "队伍 {{number}}",
    "noPosse": "无编队技能",
    "tokenMissing": "缺少代码标记",
    "railAwakeners": "唤醒体：{{names}}。",
    "railWheels": "命轮：{{names}}。",
    "railPosse": "编队技能：{{name}}。"
  },
  "recommended": {
    "title": "推荐队伍",
    "slotLabel": "推荐配置位置 {{number}}",
    "copy": "复制代码",
    "copied": "已复制",
    "copyFailed": "无法访问剪贴板。",
    "covenant": "密契",
    "posse": "编队技能",
    "emptyTitle": "暂无推荐队伍",
    "emptyDescription": "请在 data/recommended-teams.json 中添加队伍并重新构建网站。"
  },
  "picker": {
    "emptyTitle": "选择一个位置开始。",
    "nowEditing": "当前编辑",
    "close": "关闭选择器",
    "label": "{{target}}选择器",
    "search": "搜索名称、别名或标签",
    "searchLabel": "搜索记录",
    "clearSearch": "清空搜索",
    "primaryFilters": "主要筛选",
    "rarityFilters": "稀有度筛选",
    "all": "全部",
    "allRarity": "全部稀有度",
    "recordCount": "{{count}} 条记录",
    "clearSlot": "清空位置",
    "realmLimit": "界域数量已达上限",
    "realmLimitDetail": "选择该唤醒体会超过两个界域的限制。",
    "replace": "替换",
    "planningOnly": "仅供规划",
    "noResults": "没有符合条件的记录。"
  },
  "target": {
    "posse": "编队技能",
    "awakener": "唤醒体 {{number}}",
    "wheel": "位置 {{slot}} · 命轮 {{wheel}}",
    "covenant": "位置 {{slot}} · 密契"
  },
  "import": {
    "format": "游戏 17 字段格式",
    "title": "导入队伍代码",
    "description": "粘贴 Morimens 分享代码，预览阵容以及跨队伍移动。",
    "placeholder": "@@在此粘贴代码@@",
    "inputLabel": "Morimens 分享代码",
    "close": "关闭",
    "empty": "空",
    "noPosse": "无编队技能",
    "conflicts": "将被清除的冲突",
    "conflictItem": "{{entity}}（来自{{team}}）",
    "noConflicts": "没有跨队伍冲突。",
    "cancel": "取消",
    "confirm": "导入队伍",
    "preview": "预览导入"
  },
  "about": {
    "kicker": "构建来源",
    "title": "数据、署名与使用说明",
    "close": "关闭",
    "currentData": "当前数据",
    "generated": "生成于 {{date}}",
    "noncommercial": "非商业同人项目",
    "notAffiliated": "与 Qookka Games 无关联，也未获得其认可。",
    "skeydbNotice": "本项目包含由 dansa 与 SKeyDB 贡献者创建的 Morimens 社区数据及内容。SKeyDB 原创数据依照 CC BY-NC-SA 4.0 许可使用。游戏名称、美术、文本及其他游戏素材的权利归 Qookka Games 和／或其许可方所有。",
    "huijiNotice": "部分编队技能及历史美术素材署名于 Morimens 灰机 Wiki 社区，并依照其适用条款使用。",
    "source": "查看 SKeyDB 源项目",
    "counts": "{{awakeners}} 名唤醒体 · {{wheels}} 个命轮 · {{covenants}} 件密契 · {{posses}} 个编队技能"
  },
  "toast": {
    "undo": "撤销",
    "dismiss": "关闭",
    "invalid": "该分配无效。",
    "move": "已从原队伍移动，可撤销。",
    "assigned": "已分配。",
    "selectionRestored": "已恢复分配。",
    "clearedRestored": "已恢复清除的内容。",
    "selectionCleared": "已清空位置。",
    "teamRestored": "已恢复队伍。",
    "teamCleared": "已清空队伍。",
    "allRestored": "已恢复全部队伍。",
    "allReset": "已重置全部队伍。",
    "importReverted": "已撤销导入。",
    "imported": "队伍已导入，冲突位置已清除。",
    "dataUpdated": "游戏数据已更新，保存的队伍已完成校正。",
    "copyFailed": "无法访问剪贴板，请手动复制代码。"
  },
  "errors": {
    "targetMissing": "目标队伍已不存在。",
    "unknownCovenant": "未知密契。",
    "unknownEntity": "未知实体。",
    "entityNotSelectable": "该兼容实体无法被新选择。",
    "realmMove": "此次移动会超过两个界域的限制。",
    "noToken": "以下项目没有分享代码标记：{{names}}。",
    "invalidWrapper": "未找到有效的 @@分享代码@@ 内容。",
    "unknownAwakener": "唤醒体代码未知或已过期。",
    "unknownWheel": "命轮代码未知或已过期。",
    "unknownCovenantToken": "密契代码未知或已过期。",
    "unknownPosse": "编队技能代码未知或已过期。",
    "trailingData": "分享代码包含多余数据，或与当前数据版本不匹配。",
    "duplicateEntity": "分享代码重复分配了同一唯一实体。",
    "importRealm": "导入的队伍超过了两个界域的限制。"
  },
  "enums": {
    "AEQUOR": "深海",
    "CARO": "血肉",
    "CHAOS": "混沌",
    "ULTRA": "超维",
    "FADED_LEGACY": "忘却篇",
    "OTHER": "其他",
    "ALIEMUS_REGEN": "狂气回充",
    "CRIT_DMG": "暴击伤害",
    "CRIT_RATE": "暴击率",
    "DEATH_RESISTANCE": "死亡抵抗",
    "DMG_AMP": "伤害强效",
    "KEYFLARE_REGEN": "银钥充能",
    "REALM_MASTERY": "界域精通",
    "SIGIL_YIELD": "黑印掉落"
  }
}
